import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/msal-services/auth-service';
import { Router, RouterModule } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { filter } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [CommonModule, ButtonModule, RouterModule],
  template: `
    <div
      class="surface-ground w-full min-h-screen flex justify-content-center align-items-center p-3"
    >
      <div
        class="dark-background p-4 shadow-4 border-round-lg w-full sm:w-10 md:w-6 lg:w-4 flex flex-column align-items-center"
      >
        <!-- Logo or Skeleton -->
        <ng-container *ngIf="preloadedImages[key]; else logoSkeleton">
          <img
            [src]="preloadedImages[key]"
            alt="CBP Logo"
            class="mb-3"
            style="max-width: 180px"
          />
        </ng-container>
        <ng-template #logoSkeleton>
          <div
            class="mb-3 w-40 h-40 bg-gray-300 animate-pulse rounded-full"
          ></div>
        </ng-template>

        <!-- Title -->
        <h2 class="text-center text-white mb-2">Login Redirect</h2>

        <ng-container *ngIf="loggedIn$ | async; else loggedOut">
          <p-button
            [routerLink]="'/home'"
            label="Go back to Homepage"
            icon="pi pi-home"
            severity="success"
            class="full-width-p-button"
          ></p-button>
        </ng-container>

        <ng-template #loggedOut>
          <h4 class="text-center mb-4">Please log in to continue.</h4>

          <p-button
            (click)="onLogin()"
            label="Login with SSO"
            severity="success"
            class="full-width-p-button"
          ></p-button>
        </ng-template>
      </div>
    </div>
  `,
  styleUrls: [],
})
export class RedirectComponent implements OnInit {
  preloadedImages: { [key: string]: string } = {};
  key = 'F5F62799-1891-4EC3-B538-0797C3858AB4';
  private redirectHandled = false;
  loggedIn$ = this.authService.loggedIn$;
  constructor(
    private authService: AuthService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.preloadedImages[this.key] =
      '../../../../assets/images/CB-Logo-white.webp';
    // Handle MSAL redirect
    this.msalBroadcastService.inProgress$
      .pipe(filter((status) => status === InteractionStatus.None))
      .subscribe(async () => {
        if (this.redirectHandled) return;
        this.redirectHandled = true;

        await this.authService.handleRedirect();

        const activeAccount = this.authService.getActiveAccount();
        if (activeAccount) {
          try {
            await this.authService.acquireTokenSilent();
          } catch (err) {
            console.error('[RedirectComponent] Token acquisition failed:', err);
          }

          const returnUrl =
            localStorage.getItem('returnUrl') || this.router.url;
          localStorage.removeItem('returnUrl');
          if (returnUrl !== this.router.url) {
            this.router
              .navigateByUrl(returnUrl)
              .catch((err) =>
                console.error('[RedirectComponent] Navigation error:', err),
              );
          }
        }
      });
  }

  onLogin(): void {
    this.authService.login();
  }
}
